export default class Schedule {
  ID: number;
  PLID: number;
  NAME: string;
  MONTAGSTART: string | null;
  MONTAGSTOP: string | null;
  DIENSTAGSTART: string | null;
  DIENSTAGSTOP: string | null;
  MITTWOCHSTART: string | null;
  MITTWOCHSTOP: string | null;
  DONNERSTAGSTART: string | null;
  DONNERSTAGSTOP: string | null;
  FREITAGSTART: string | null;
  FREITAGSTOP: string | null;
  SAMSTAGSTART: string | null;
  SAMSTAGSTOP: string | null;
  SONNTAGSTART: string | null;
  SONNTAGSTOP: string | null;
  StartDate: string | null;
  StopDate: string | null;

  constructor(
    PLID: number,
    ID?: number,
    NAME?: string,
    MONTAGSTART?: string | null,
    MONTAGSTOP?: string | null,
    DIENSTAGSTART?: string | null,
    DIENSTAGSTOP?: string | null,
    MITTWOCHSTART?: string | null,
    MITTWOCHSTOP?: string | null,
    DONNERSTAGSTART?: string | null,
    DONNERSTAGSTOP?: string | null,
    FREITAGSTART?: string | null,
    FREITAGSTOP?: string | null,
    SAMSTAGSTART?: string | null,
    SAMSTAGSTOP?: string | null,
    SONNTAGSTART?: string | null,
    SONNTAGSTOP?: string | null,
    StartDate?: string | null,
    StopDate?: string | null
  ) {
    this.ID = ID || 0;
    this.PLID = PLID || 0;
    this.NAME = NAME || "";
    this.MONTAGSTART = MONTAGSTART || null;
    this.MONTAGSTOP = MONTAGSTOP || null;
    this.DIENSTAGSTART = DIENSTAGSTART || null;
    this.DIENSTAGSTOP = DIENSTAGSTOP || null;
    this.MITTWOCHSTART = MITTWOCHSTART || null;
    this.MITTWOCHSTOP = MITTWOCHSTOP || null;
    this.DONNERSTAGSTART = DONNERSTAGSTART || null;
    this.DONNERSTAGSTOP = DONNERSTAGSTOP || null;
    this.FREITAGSTART = FREITAGSTART || null;
    this.FREITAGSTOP = FREITAGSTOP || null;
    this.SAMSTAGSTART = SAMSTAGSTART || null;
    this.SAMSTAGSTOP = SAMSTAGSTOP || null;
    this.SONNTAGSTART = SONNTAGSTART || null;
    this.SONNTAGSTOP = SONNTAGSTOP || null;
    this.StartDate = StartDate || null;
    this.StopDate = StopDate || null;
  }

  setMondayNull() {
    this.MONTAGSTART = null;
    this.MONTAGSTOP = null;
  }

  setTuesdayNull() {
    this.DIENSTAGSTART = null;
    this.DIENSTAGSTOP = null;
  }

  setWednessdayNull() {
    this.MITTWOCHSTART = null;
    this.MITTWOCHSTOP = null;
  }

  setThursdayNull() {
    this.DONNERSTAGSTART = null;
    this.DONNERSTAGSTOP = null;
  }

  setFridayNull() {
    this.FREITAGSTART = null;
    this.FREITAGSTOP = null;
  }

  setSaturdayNull() {
    this.SAMSTAGSTART = null;
    this.SAMSTAGSTOP = null;
  }

  setSundayNull() {
    this.SONNTAGSTART = null;
    this.SONNTAGSTOP = null;
  }

  clone() {
    return new Schedule(
      this.PLID,
      this.ID,
      this.NAME,
      this.MONTAGSTART,
      this.MONTAGSTOP,
      this.DIENSTAGSTART,
      this.DIENSTAGSTOP,
      this.MITTWOCHSTART,
      this.MITTWOCHSTOP,
      this.DONNERSTAGSTART,
      this.DONNERSTAGSTOP,
      this.FREITAGSTART,
      this.FREITAGSTOP,
      this.SAMSTAGSTART,
      this.SAMSTAGSTOP,
      this.SONNTAGSTART,
      this.SONNTAGSTOP,
      this.StartDate,
      this.StopDate
    );
  }

  static fromObject(obj: {
    ID: number;
    PLID: number;
    NAME: string;
    MONTAGSTART: string;
    MONTAGSTOP: string;
    DIENSTAGSTART: string;
    DIENSTAGSTOP: string;
    MITTWOCHSTART: string;
    MITTWOCHSTOP: string;
    DONNERSTAGSTART: string;
    DONNERSTAGSTOP: string;
    FREITAGSTART: string;
    FREITAGSTOP: string;
    SAMSTAGSTART: string;
    SAMSTAGSTOP: string;
    SONNTAGSTART: string;
    SONNTAGSTOP: string;
    startDate: string;
    endDate: string;
  }) {
    return new Schedule(
      obj.PLID,
      obj.ID,
      obj.NAME,
      obj.MONTAGSTART,
      obj.MONTAGSTOP,
      obj.DIENSTAGSTART,
      obj.DIENSTAGSTOP,
      obj.MITTWOCHSTART,
      obj.MITTWOCHSTOP,
      obj.DONNERSTAGSTART,
      obj.DONNERSTAGSTOP,
      obj.FREITAGSTART,
      obj.FREITAGSTOP,
      obj.SAMSTAGSTART,
      obj.SAMSTAGSTOP,
      obj.SONNTAGSTART,
      obj.SONNTAGSTOP,
      obj.startDate,
      obj.endDate
    );
  }

  toObject() {
    return {
      plID: this.PLID,
      schedID: this.ID,
      schedName: this.NAME,
      startDate: this.StartDate,
      endDate: this.StopDate,
      mostart: this.MONTAGSTART,
      mostop: this.MONTAGSTOP,
      distart: this.DIENSTAGSTART,
      distop: this.DIENSTAGSTOP,
      mistart: this.MITTWOCHSTART,
      mistop: this.MITTWOCHSTOP,
      dostart: this.DONNERSTAGSTART,
      dostop: this.DONNERSTAGSTOP,
      frstart: this.FREITAGSTART,
      frstop: this.FREITAGSTOP,
      sastart: this.SAMSTAGSTART,
      sastop: this.SAMSTAGSTOP,
      sostart: this.SONNTAGSTART,
      sostop: this.SONNTAGSTOP,
    };
  }

  clear() {
    this.StartDate = "";
    this.StopDate = "";
    this.NAME = "";
    this.MONTAGSTART = "";
    this.MONTAGSTOP = "";
    this.DIENSTAGSTART = "";
    this.DIENSTAGSTOP = "";
    this.MITTWOCHSTART = "";
    this.MITTWOCHSTOP = "";
    this.DONNERSTAGSTART = "";
    this.DONNERSTAGSTOP = "";
    this.FREITAGSTART = "";
    this.FREITAGSTOP = "";
    this.SAMSTAGSTART = "";
    this.SAMSTAGSTOP = "";
    this.SONNTAGSTART = "";
    this.SONNTAGSTOP = "";
    this.ID = 0;
  }
}
